import { render, staticRenderFns } from "./ShowStep.vue?vue&type=template&id=bcc7d1d4&scoped=true"
import script from "./ShowStep.vue?vue&type=script&lang=ts"
export * from "./ShowStep.vue?vue&type=script&lang=ts"
import style0 from "./ShowStep.vue?vue&type=style&index=0&id=bcc7d1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc7d1d4",
  null
  
)

export default component.exports